import { mapGetters } from 'vuex';

import { MENU } from '@/utils/menu.js';

export default {
  props: ['mobileMenu'],
  computed: {
    ...mapGetters({
      userRole: 'userRole',
      permissions: 'permissions',
    }),
    pages() {
      return MENU.leftMenu.filter((item) => {
        return this.permissions.includes(item.permission) &&
          !(Array.isArray(item.roleDisable) && item.roleDisable.includes(this.userRole));
      });
    },
  },
  methods: {
    getActive (menuUrl, currentUrl) {
      return menuUrl.split('/')[1] == currentUrl.split('/')[1] ? 'active' : '';
    },
    getActiveSubmenu (menuUrl, currentUrl) {
      return menuUrl.split('/')[2] == currentUrl.split('/')[2] ? 'active' : '';
    },
    logOut () {
      this.$store.dispatch('LOGOUT');
      this.$store.dispatch('SHOW_SESSION_BLOCK');
      this.$router.push({ name: 'auth' });
    },
  },
};
